<template>
    <div class="page-logo">
        <router-link to="/">
            <img v-if="pageLogo" :alt="wpvue.blogname" :title="wpvue.blogname" :src="pageLogo.url" />
        </router-link>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'page-logo',
    props: {
        // in PX
        light: {
            type: Boolean,
            default: false,
        },
    },
    data(){
        return{
            wpvue : window.WPVUE,
        }
    },
    computed:{
        ...mapGetters([
            'getOptions',
        ]),
       pageLogo(){
            const logoLight = (this.getOptions && this.getOptions.logo_white && this.getOptions.logo_white.id) ? this.getOptions.logo_white : false
            const logoDark = (this.getOptions && this.getOptions.logo && this.getOptions.logo.id) ? this.getOptions.logo : false
            return this.light ? logoLight || logoDark : logoDark || logoLight
        },
    },
    
};
</script>


<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";
.page-logo{
    
}
</style>